export default "__VITE_ASSET__$emJz2gA__"